import React from 'react'

import Wizard from '@modules/form-wizard'
import SERVICE_PROPS from '@helpers/extract-service-props'
import { BUSINESS_FIELDS } from '@modules/form-wizard/utils'
import convertToBase64 from '@helpers/file-to-base64'

export default class LpgSubDealerApplication extends React.Component {
  resource = '/liquid_petroleum_gas'
  form_key = 'liquid_petroleum_gas'

  isDealer = this.props.location.pathname.includes('-dealer')
  isSubDealer = this.props.location.pathname.includes('-sub')
  isInstaller = this.props.location.pathname.includes('-installer')

  setLicenseType = () => {
    console.log(this.isDealer)
    if (this.isDealer) return 'dealer'
    else if(this.isSubDealer) return 'sub-dealer'
    else if(this.isInstaller) return 'installer'
  }

  defaults = {
    license_type: this.setLicenseType(),
    certified_holders_list: [
      {
        f_name: '',
        m_name: '',
        l_name: '',
        cert_upload: ''
      },
      {
        f_name: '',
        m_name: '',
        l_name: '',
        cert_upload: ''
      },
    ]
  }

  read_params = {
    admin: true,
    label: ' ',
    default: 'Default',
    values: {
      'Default': {
        license_type: this.setLicenseType(),
      },
    },
  }

  // Delete lines as needed
  fee = ({ license_type }) => ({
    'dealer': 300.0,
    'sub-dealer': 150.0,
    'installer': 30.0,
  })[license_type]
  // free = true
  // postpaid = true
  skip_location = true
  hide_buttons = false
  custom_actions = []
  business_only = true

  validate = async form => {
    const update = {}

    let index = 0

    if(form.certified_holders_list[0]) {
      update.certified_holders_list = []

      for (let row of form.certified_holders_list) {
        const {
          cert_upload,
          f_name,
          l_name,
          ...item
        } = row
        index ++

        if(cert_upload){
          item.cert_upload = await convertToBase64(cert_upload);
          item.title = `${f_name} ${l_name}'s Certificate - ${index}`;
          item.desc = `Certificate - ${index}`;
          update.certified_holders_list.push(item);
        }
      }
  }

    return update
  }

  foremost = null

  /*
  t.boolean :renewal, default: false
      t.string :license_type # dealer, sub-dealer, installer, container re-builder, or appliance dealer

      # Dealer Sub-Dealer or Installer
      t.string :certified_technicians_list, array: true, default: []
      t.string :storage_capacity
      t.attachment :insurance_letter_upload
      t.string :manager_f_name
      t.string :manager_l_name

      # Rebuilder of Containers
      t.string :rebuilding_equipment_list, array: true, default: []
      t.string :welding_equipment_details
      t.string :test_jacket_details
      t.string :certified_welders_list, array: true, default: []

      # Appliance Dealer
      t.string :appliance_manufacturer
      t.string :appliance_type
      t.string :appliance_model
      t.attachment :appliance_verification_upload
  */

  fields = form => [
    ...BUSINESS_FIELDS(form),
    {
      name: 'license_type',
      label: 'What type of license are you applying for?',
      hide: true,
      save: true,
    },
    {
      name: 'renewal',
      label: 'Are you applying for the renewal of a license?',
      type: 'select:bool',
    },
    {
      name: 'amount_of_tanks',
      label: 'Total amount of tanks',
      type: 'integer',
    },
    {
      name: 'storage_capacity_total',
      label: 'Total Storage capacity of all tanks',
      type: 'integer',
      hint: 'gallons'
    },
    {
      name: 'insurance_letter_upload',
      label: 'Insurance letter',
      key: 'image.0',
      type: 'file:all',
    },

    '::Person who will manage operations',
    {
      name: 'manager_f_name',
      label: 'First Name',
    },
    {
      name: 'manager_l_name',
      label: 'Last Name',
    },

    {
      name: 'certified_holders_list',
      label: 'Names of persons in organization holding Liquified Petroleum Gas Certificates of Competency',
      fields: [
        { name: 'f_name', label: 'First Name' },
        { name: 'm_name', label: 'Middle Name', required: false },
        { name: 'l_name', label: 'Last Name' },
        { name: 'cert_upload', label: 'Certification Upload', type: 'file:all', required: false },
      ],
      min: 2,
    },

    // '::Rebuilder of Containers',
    // {
    //   name: 'welding_equipment_details',
    //   type: 'textarea',
    // },
    // {
    //   name: 'test_jacket_details',
    //   type: 'textarea',
    // },
    // {
    //   name: 'certified_welders_list',
    //   label:
    //     'Name and welding certificates of persons who will be carrying out the welding',
    //   columns: ['first_name', 'last_name', 'certificate'],
    // },
    // '::Appliance Dealer',
    // {
    //   name: 'appliance_manufacturer',
    // },
    // {
    //   name: 'appliance_type',
    // },
    // {
    //   name: 'appliance_model',
    // },
    // {
    //   name: 'appliance_verification_upload',
    //   label:
    //     'Verification that the appliances have been manufactured in accordance with either the American or Canadian Gas Association standards',
    //   key: 'image.1',
    //   type: 'file:all',
    // },
  ]

  render = () => <Wizard {...SERVICE_PROPS(this)} />
}
